// extracted by mini-css-extract-plugin
export default {"footerRoot":"Footer_footerRoot__KKNcZ","text":"Footer_text__IICV-"};